import { useQuery, useQueryClient } from '@tanstack/react-query';
import Widget from './Widget';
import { Col } from 'react-bootstrap';
import { fetchDefectsLogged } from '../../../../../modules/dashboard';
import QUERY_KEYS from '../../../../../query/queryKeys';
import { useRef } from 'react';

const DefectsLoggedInProject = ({
  projectId,
  isJiraIntegrated,
  isAdmin,
  selectedJiraProject,
}) => {
  const queryClient = useQueryClient();
  const forceRefreshRef = useRef(false);
  const jiraProjectId = selectedJiraProject?.linked_project_id;
  const { data, isLoading, isFetching } = useQuery({
    queryKey: QUERY_KEYS.projectDashboard.defectsLogged(
      projectId,
      jiraProjectId
    ),
    queryFn: async () => {
      const currentForceRefresh = forceRefreshRef.current;
      forceRefreshRef.current = false;
      return fetchDefectsLogged(projectId, jiraProjectId, currentForceRefresh);
    },
    enabled: isJiraIntegrated && !!selectedJiraProject,
  });

  const handleRefresh = () => {
    forceRefreshRef.current = true;
    queryClient.refetchQueries({
      queryKey: QUERY_KEYS.projectDashboard.defectsLogged(projectId, jiraProjectId),
      exact: true,
    });
  };

  return (
    <>
      <Col className="test-cycle-widget">
        <Widget
          title="Total Defects"
          body={data?.total_defects ?? 0}
          showWarning={!isJiraIntegrated}
          loading={isLoading}
          showRefreshButton={!isLoading && isJiraIntegrated}
          onRefresh={handleRefresh}
          isFetching={isFetching}
          link={data?.totaljira_url ?? null}
        />
      </Col>
      {isAdmin && (
        <Col className="test-cycle-widget">
          <Widget
            title="Open Defects"
            body={data?.total_open_defects ?? 0}
            showWarning={!isJiraIntegrated}
            link={data?.jira_url ?? null}
            loading={isLoading}
          />
        </Col>
      )}
    </>
  );
};

export default DefectsLoggedInProject;
